export const ORDERLOCATIONS_LOADING = 'REDUX_SAGA_ORDERLOCATIONS_LOADING';
export const SET_ORDERLOCATIONS = 'REDUX_SAGA_SET_ORDERLOCATIONS';
export const ORDERLOCATIONS_SUCCESS = 'REDUX_SAGA_ORDERLOCATIONS_SUCCESS';
export const ORDERLOCATIONS_ERROR = 'REDUX_SAGA_ORDERLOCATIONS_ERROR';

export const actionGetOrderLocationsByDisplayArea = (dispatch, displayArea) => {
    dispatch({ type: ORDERLOCATIONS_LOADING, payload: displayArea })
};

export const actionSetOrderLocation = (dispatch, orderLocation) => {
    dispatch({ type: SET_ORDERLOCATIONS, payload: orderLocation })
};